<template>
  <div>
    <el-row class="el-row">
      <el-col :span="1.5"  class="left_l">
        <el-button type="primary" @click="addSonDevice">添加子设备</el-button>
      </el-col>
      <el-col :span="5.5" class="left_r">
        <el-input
        placeholder="请输入DeviceName"
        v-model="subDeviceName"
        @focus="inputFocus"
        @blur="inputBlur"
        :class="active ? 'active' : '' "
        @keyup.13.native="handlerKeyUp"
        >
          <el-button slot="append" icon="el-icon-search" @click="clickHandlerById" ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- table表格 -->
    <el-table
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      :data="tableData"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
      class="table">
      <el-table-column
        :reserve-selection="true"
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="deviceName"
        label="DeviceName"
        width="180">
      </el-table-column>
      <el-table-column
        prop="productName"
        label="设备所属产品">
      </el-table-column>
      <el-table-column
        prop="nodeType"
        label="节点类型">
        <template slot-scope="scope">
          {{scope.row.nodeType === 0 ? '直连设备' : scope.row.nodeType === 1 ? '网关子设备' : '网关设备'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="deviceStatus"
        label="状态/启用状态">
        <template slot-scope="scope">
          <div class="stateContent">
            <div :class="['dot',scope.row.btnState.class]"></div>
            {{scope.row.btnState.state}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="lastOnlineTime"
        label="最后上线时间">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="view(scope.row, 'view')">查看</el-button>
          <el-button type="danger" size="small" @click="view(scope.row, 'delete')" style="margin-left:10px">解绑</el-button>
          <el-button v-if="scope.row.isEnable" :disabled="scope.row.piIsEnable === false" @click="enableChange(scope.row)" type="warning" size="small"  style="margin-left:10px">禁用</el-button>
          <el-button v-else @click="enableChange(scope.row)" size="small" type="success" slot="reference">启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Paging :total="total" @changePage="changePage"/>
    <el-row class="handler" type="flex" align="middle">
       <!-- <div style="padding-left:14px">
        <el-checkbox v-model="checked"></el-checkbox>
       </div> -->
       <el-button :disabled="this.multipleSelection.length === 0" size="small" @click="handlerUnbind('deleteAll')">批量解绑</el-button>
       <el-button :disabled="this.multipleSelection.length === 0" size="small" @click="batchEnableChange('disable')">批量禁用</el-button>
       <el-button :disabled="this.multipleSelection.length === 0" size="small"  @click="batchEnableChange('enable')">批量启用</el-button>
    </el-row>
    <AddSon v-if="dialogFormVisible" :dialogFormVisible="dialogFormVisible" :productKey="productKey" :deviceName="deviceName" @closeDialog="closeDialog"/>
  </div>
</template>
<script>
import { subDeviceIdListPage, enableDevice, disableDevice, unbind } from '@/api/deviceManagement'
import Paging from '@/components/paging'
import AddSon from '@/components/deviceManage/addSon'
export default {
  components: {
    Paging,
    AddSon
  },
  props: {
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    }
  },
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      active: false,
      subDeviceName: '',
      tableData: [],
      // table 复选框
      // checked: false,
      // 子组件
      dialogFormVisible: false,
      multipleSelection: [] // 存放选中数据
    }
  },
  created () {
    console.log('子设备管理页面数据', this.productKey, this.deviceName)
    this.getSubDeviceIdListPage()
  },
  watch: {
    multipleSelection: {
      handler (val) {
        console.log(val)
      }
    }
  },
  methods: {
    chagneStatus (item) {
      // ONLINE：在线。0
      // OFFLINE：离线。1
      // UNACTIVE：未激活。2
      // DISABLE：已禁用。3
      const stateParams = {
        0: 'ONLINE',
        1: 'OFFLINE',
        2: 'UNACTIVE',
        3: 'DISABLE'
      }
      const classParams = {
        0: 'online',
        1: 'offline',
        2: 'inactive',
        3: 'disabled'
      }
      const key = item.deviceStatus.toString()
      item.btnState = { isOpen: key === '0', state: stateParams[key], class: classParams[key] }
    },
    // 禁用启用单个
    enableChange (row) {
      const params = {
        deviceDTOS: [
          {
            deviceName: row.deviceName,
            productKey: row.productKey
          }
        ]
      }
      row.isEnable
        ? disableDevice(params).then(res => {
          res = res.data
          console.log('禁用返回：', res)
          row.isEnable = !row.isEnable
          this.chagneStatus(row)
          // 重新获取列表刷新
          this.getSubDeviceIdListPage()
        })
        : enableDevice(params).then(res => {
          res = res.data
          console.log('启用返回：', res)
          row.isEnable = !row.isEnable
          this.chagneStatus(row)
          // 重新获取列表刷新
          this.getSubDeviceIdListPage()
        })
    },
    // 批量禁用启用
    batchEnableChange (type) {
      const params = {
        deviceDTOS: this.multipleSelection.map(item => {
          return {
            deviceName: item.deviceName,
            productKey: item.productKey
          }
        })
      }
      console.log('批量params：', params)
      this.multipleSelection && this.multipleSelection.length > 0
        ? type === 'disable'
          ? disableDevice(params).then(res => {
            res = res.data
            console.log('批量禁用返回：', res)
            setTimeout(() => {
              // 重新获取列表刷新
              this.getSubDeviceIdListPage()
            }, 1000)
          })
          : enableDevice(params).then(res => {
            res = res.data
            console.log('批量启用返回：', res)
            setTimeout(() => {
              // 重新获取列表刷新
              this.getSubDeviceIdListPage()
            }, 1000)
          })
        : this.$message({
          type: 'info',
          message: '请先选择设备'
        })
    },
    // 批量解绑
    handlerUnbind () {
      console.log(this.multipleSelection)
      this.$confirm(`确定批量解绑这${this.multipleSelection.length}个子设备?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const subDeviceUnbindList = []
        this.multipleSelection.forEach(e => {
          const obj = {}
          obj.productKey = e.productKey
          obj.deviceName = e.deviceName
          subDeviceUnbindList.push(obj)
        })
        console.log(subDeviceUnbindList)
        const params = {
          parentProductKey: this.productKey,
          parentDeviceName: this.deviceName
        }
        params.subDeviceDeleteList = subDeviceUnbindList
        unbind(params).then((Res) => {
          console.log(Res)
          if (Res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '批量解绑操作成功'
            })
            this.multipleSelection.length = 0
            this.listQuery.page = 1
            this.getSubDeviceIdListPage()
          } else {
            this.$message({
              type: 'error',
              message: Res.data.message
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消批量解绑'
        })
      })
    },
    getRowKeys (row) {
      return row.deviceId // id为列表数据的唯一标识
    },
    // table栏val选择的事件
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    getSubDeviceIdListPage () {
      const params = {
        pageNum: this.listQuery.page,
        pageSize: this.listQuery.limit,
        productKey: this.productKey,
        deviceName: this.deviceName,
        subDeviceName: this.subDeviceName
      }
      subDeviceIdListPage(params).then(res => {
        console.log(res.data.data.data.list)
        this.tableData = res.data.data.data.list
        this.total = res.data.data.data.total
        this.tableData.forEach(item => {
          this.chagneStatus(item)
        })
      })
    },
    // 添加子设备
    addSonDevice () {
      this.dialogFormVisible = true
    },
    // 关闭子设备弹窗
    closeDialog (val) {
      this.dialogFormVisible = false
      if (val) {
        this.getSubDeviceIdListPage()
      }
    },
    // 输入框聚焦
    inputFocus () {
      this.active = true
    },
    // 输入框失焦
    inputBlur () {
      this.active = false
    },
    // 13键
    handlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.listQuery.page = 1
        this.clickHandlerById()
      }
    },
    // 通过deviceName搜索
    clickHandlerById () {
      this.listQuery.page = 1
      this.getSubDeviceIdListPage()
    },
    // 分页功能
    changePage (val) {
      this.listQuery = val
      this.getSubDeviceIdListPage()
    },
    view (row, val) {
      console.log(row)
      if (val === 'view') {
        this.$store.commit('SET_SUB_DEVICE_DETAIL', JSON.stringify(row))// 把设备详情缓存起来，很多地方用到,缓存成字符串，防止修改操作到对象
        this.$router.push({
          /* name: 'hasParent/deviceManagement/DeviceManager',
            params: {
              activeName: '1'
            } */
          path: '/deviceManagement/subDeviceDetail'
        })
      } else {
        const params = {}
        const obj = {}
        const subDeviceDeleteList = []
        obj.productKey = row.productKey
        obj.deviceName = row.deviceName
        subDeviceDeleteList.push(obj)
        console.log('11', subDeviceDeleteList)
        // 进行解绑操作
        params.parentProductKey = this.productKey
        params.parentDeviceName = this.deviceName
        params.subDeviceDeleteList = subDeviceDeleteList
        console.log(params)
        this.$confirm('确定解绑此子设备?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          unbind(params).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '解绑成功'
              })
              this.listQuery.page = 1
              this.getSubDeviceIdListPage()
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          })
        })
      }
    }
  }
}
</script>

<style lang='less' scoped>
  .stateContent{
      display: flex;
      align-items: center;
      // justify-content: center;
      .dot{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 5px;
      }
      .disabled{
        background-color: #996262;
      }
      .inactive{
        background-color: #999062;
      }
      .offline{
        background-color: #888888;
      }
      .online{
        background-color: #1E8E39;
      }
    }
  .el-row{
    margin-bottom: 20px;
    display: flex;
    .left_r{
      // width: 20%;
      // margin-left: 10px;
    }
    .btn-wrap{
      margin-left: 10px;
      display: inline-block;
    }
    .el-button{
      border-radius: 0;
    }
    .el-input{
      box-sizing: border-box !important;
      margin-left: 10px;
      border: 1px solid #dedede;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
      /deep/ .el-input__inner{
        border: none !important;
        height: 38px;
        line-height: 38px;
      }
      /deep/ .el-input-group__append{
        background-color: white !important;
        color: #555 !important;
        border: none !important;
      }
      /deep/ .el-icon-search{
        color: orange;
        font-size: 20px;
        font-weight: bold;
      }
    }
    .active{
      border-color: #737373;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
    }
    .el-input:hover{
      border-color: #737373;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
    }
  }
  .table{
    width: 100%;
    margin-bottom: 20px;
    .tip{
      height: 8px;
      width: 8px;
      border-radius: 50%;
      background: #888;
      display: inline-block;
      margin-right: 8px;
    }
  }
  .pagination-container{
    float: right;
  }
  /deep/.el-table__row{
    /deep/ .el-button{
      margin-left: 0;
    }
  }
  .look{
    margin-left: 10px;
  }
  /deep/ .el-table th>.cell{
    padding-left: 14px;
  }
</style>
